// extracted by mini-css-extract-plugin
module.exports = {"root":"EmailConfirmationModal_root__3JjIn","content":"EmailConfirmationModal_content__2SC6Q","title":"EmailConfirmationModal_title__34xmj"};